import { render } from "./PurchaseRegisterPaymentCallback.vue?vue&type=template&id=3b012426&ts=true"
import script from "./PurchaseRegisterPaymentCallback.vue?vue&type=script&lang=ts"
export * from "./PurchaseRegisterPaymentCallback.vue?vue&type=script&lang=ts"

import exportComponent from "/home/appstore/appstore/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__